import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

import { deleteById } from 'apis/employees.api';
import { TOAST } from 'constant';
import { toast } from 'layout';
import { mapError } from 'utils/func';

export default function ConfirmDelete({ selectedEmployee, visible, setVisible, refetch }) {
  // #region Data
  const { t } = useTranslation();

  const { mutate } = useMutation(deleteById);
  // #endregion

  // #region Event
  const footerConfirmationSubmit = () => (
    <div>
      <Button
        label={t('employee.cancel')}
        className="w-7rem"
        severity="danger"
        onClick={() => setVisible(false)}
        autoFocus
      />
      <Button
        label={t('employee.ok')}
        className="w-7rem"
        severity="info"
        onClick={() => {
          mutate(selectedEmployee?.id, {
            onSuccess: () => {
              toast(TOAST.SUCCESS, t('employee.delete.deleteSuccess'));
              setVisible(false);
              refetch();
            },
            onError: (error) => {
              toast(TOAST.ERROR, mapError(t, error));
            },
          });
        }}
      />
    </div>
  );
  // #endregion

  return (
    <Dialog
      header={<p className="text-red-500">{t('employee.delete.title')}</p>}
      visible={visible}
      position="center"
      style={{ width: '400px' }}
      onHide={() => setVisible(false)}
      draggable={false}
      footer={footerConfirmationSubmit}
    >
      <p className="text-lg">{t('employee.delete.confirmationDeleteMessage')}</p>
      <p className="text-lg font-bold">
        {selectedEmployee?.fullname} ({selectedEmployee?.email})
      </p>
    </Dialog>
  );
}

ConfirmDelete.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
  selectedEmployee: PropTypes.object,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  refetch: PropTypes.func.isRequired,
};
